import {gql} from "@apollo/client";
import {Competence} from "../../../schema";

export type competenciesQueryData = {
  competencies: Competence[];
};

export const competenciesQuery = gql`
  query EditorEditChallengeSceneCompetenciesQuery {
    competencies: getCompetencies {
      id
      name
      description
      indicators
    }
  }
`;
